"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromiseCached = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
async function getPromiseCached(fetchValue, dataCache, cacheKey, expiry = 86400000, verbose = false) {
    const inCache = dataCache.get(cacheKey);
    if (inCache) {
        if (verbose) {
            commons_logs_1.log.debug(`Returning cached data for ${cacheKey}`);
        }
        return inCache;
    }
    else {
        if (verbose) {
            commons_logs_1.log.info(`Cache for ${cacheKey} expired. Fetching data.`);
        }
        const result = fetchValue();
        dataCache.set(cacheKey, result, { ttl: expiry });
        result.catch(() => dataCache.delete(cacheKey));
        return result;
    }
}
exports.getPromiseCached = getPromiseCached;
//# sourceMappingURL=getPromiseCached.js.map